import { IconComponent } from "@/ui/icon";
import clsx from "clsx";

export type TokenValueToggleView = "sol" | "usd";

const TokenValueToggle = ({
  selectedView,
  setSelectedView,
}: {
  selectedView: TokenValueToggleView;
  setSelectedView: (view: TokenValueToggleView) => void;
}) => {
  return (
    <div className="flex items-center gap-x-[0.625rem] font-semibold text-xs">
      <div
        className={clsx(
          "flex items-center gap-x-[0.3125rem] cursor-pointer",
          selectedView === "sol" ? "opacity-100" : "opacity-50",
          "hover:opacity-100"
        )}
        onClick={() => setSelectedView("sol")}
        role="button"
      >
        <IconComponent name="solanaLogo" />
        <span>View in SOL</span>
      </div>
      <div
        className={clsx(
          "flex items-center gap-x-[0.3125rem] cursor-pointer",
          selectedView === "usd" ? "opacity-100" : "opacity-50",
          "hover:opacity-100"
        )}
        onClick={() => setSelectedView("usd")}
        role="button"
      >
        <span>$</span>
        <span>View in USD</span>
      </div>
    </div>
  );
};

export default TokenValueToggle;
